import { createApiRequest } from '../../core/util/api';
import { AUTH_FIREBASE_URL, AUTH_URL } from '../../core/util/constants';
import { loginError, loginStart, loginSuccess, requestTokenForFirebaseUserError, requestTokenForFirebaseUserStart, requestTokenForFirebaseUserSuccess } from './LoginSlice';

export const loginUser = (body: object) => createApiRequest({
  route: AUTH_URL,
  method: 'post',
  body: body,
  onStart: loginStart,
  onSuccess: loginSuccess,
  onError: loginError,
  defaultErrorMessage: 'There was an error authenticating your account.'
})();

export const requestTokenForFirebaseUser = (userToken: string) =>
  createApiRequest({
    route: AUTH_FIREBASE_URL,
    method: 'post',
    body: { id_token: userToken },
    onStart: requestTokenForFirebaseUserStart,
    onSuccess: requestTokenForFirebaseUserSuccess,
    onError: requestTokenForFirebaseUserError,
    defaultErrorMessage: 'Unable to Log In. Please try again.'
    // useGlobalLoader: true
  })();
